module.exports = __webpack_public_path__ + "img/honduras.1135f601.svg";